import { Box } from "@chakra-ui/layout"
import { FC } from "react"

export const Header: FC = () => (
	<Box position="fixed" display={{ base: "block", lg: "none" }}>
		Header
	</Box>
)
